import { useCallback } from "react";
import { Chip } from "~/common/m3/Chip/Chip";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { useDispatch } from "react-redux";
import { clearAll } from "../../../../redux/actions";
import { Link } from "../../../../../common/components/Link";

import { useTranslation } from "react-i18next";

import { useSearchPageType } from "~/Search/useSearchPageType";
import { type AppliedFilterData } from "~/Search/components/Filters/components/AppliedFilters/useSelectAppliedFilters";

export const AppliedFilters = ({
  hideClearAll,
  appliedFilters,
}: {
  hideClearAll?: boolean;
  appliedFilters: AppliedFilterData[];
}) => {
  const { t } = useTranslation();

  const searchPageType = useSearchPageType();
  const dispatch = useDispatch();
  const onClearAll = useCallback(() => dispatch(clearAll(searchPageType)), [searchPageType]);

  if (!appliedFilters.length) {
    return null;
  }

  return (
    <Stack spacing={1} direction={"row"} sx={{
      flexWrap: "wrap"
    }}>
      {appliedFilters.map(({ key, value, onClick }) => (
        <Chip key={key} variant="filter" selected label={value} deleteIcon={<CloseIcon />} onDelete={onClick} />
      ))}
      {!hideClearAll && <ClearLink onClick={onClearAll}>{t("searchPage.refinement.button.clearAll")}</ClearLink>}
    </Stack>
  );
};

const ClearLink = styled(Link)(({ theme }) => ({
  whiteSpace: "nowrap",
}));
